/**
 * SSR Error Handling Plugin
 * Provides graceful fallback to SPA mode when SSR fails
 * Ensures content is still accessible for SEO and users
 */

export default defineNuxtPlugin({
  name: 'ssr-error-handler',
  setup() {
    // Client-side error boundary for hydration issues
    if (process.client) {
      // Handle hydration mismatches gracefully
      window.addEventListener('error', (event) => {
        if (event.message && event.message.includes('hydration')) {
          console.warn('[SSR Fallback] Hydration error detected, falling back to client-side rendering')
          // Allow the error to be handled by Vue's error boundary
          return true
        }
      })

      // Handle unhandled promise rejections that might affect SSR
      window.addEventListener('unhandledrejection', (event) => {
        if (event.reason && event.reason.message && event.reason.message.includes('fetch')) {
          console.warn('[SSR Fallback] API fetch error during hydration:', event.reason.message)
          // Don't prevent the default to allow proper error handling
        }
      })
    }

    // Server-side error logging
    if (process.server) {
      // Enhanced error logging for SSR failures
      const originalConsoleError = console.error
      console.error = (...args) => {
        // Check if this is an SSR-related error
        const errorString = args.join(' ')
        if (errorString.includes('useAsyncData') || 
            errorString.includes('$fetch') || 
            errorString.includes('Cannot read properties of undefined')) {
          console.warn('[SSR] Potential SSR failure detected:', ...args)
        }
        originalConsoleError.apply(console, args)
      }
    }
  }
})
